<div class="w-full max-w-4xl p-8">
    <div class="prose prose-sm !max-w-100 col-span-4 mb-4">
        <h2>{{ 'label_pension_benefit_coefficient' | translatePlural }}</h2>
    </div>

    <span class="separator-line block"></span>
    <br />

    <mat-tab-group class="sm:px-2 hjalp-tab-group fade-in-left" [animationDuration]="'0'">
        <mat-tab [label]="'label_acquisition_coefficient' | translatePlural">
            <pension-coefficients-acquisition></pension-coefficients-acquisition>
        </mat-tab>
        <mat-tab [label]="'label_pension_payout_coefficients' | translate">
            <pension-coefficients-payout
                (onHasPendingChanges)="setChildHasPendingChanges($event, 'acquisition')"
            ></pension-coefficients-payout>
        </mat-tab>
    </mat-tab-group>
</div>
